import { GamesTable } from "@/components/chess/table/games-table";
import { PageCardContainer } from "@/components/shared/page-card/page-card-container";
import { getPageSummary, PAGE } from "@/pages";
import type { ChessGameLite } from "@chesspresso/chess";
import { ChessGameRepository } from "@chesspresso/chess/src/db/chess-game-repository";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(container)/games")({
    component: RouteComponent,
    loader: async () => {
        const games = await ChessGameRepository.getAllLite();

        return {
            games,
        };
    },
});

const page = getPageSummary(PAGE.Games);

function RouteComponent() {
    const data = Route.useLoaderData();
    const navigate = useNavigate();
    if (!data || !data.games || data.games.length === 0) {
        return <div>No games found.</div>;
    }
    const games = data.games.toSorted((a, b) => b.endTimeUnix - a.endTimeUnix);

    const onAnalyzeClick = (game: ChessGameLite) => {
        navigate({ to: "/analyze/$slug", params: { slug: game.slug } });
    };

    return (
        <PageCardContainer
            Icon={page.icon}
            title={page.title}
            description="Browse and analyze your chess games"
            className="mx-auto max-w-[350px] md:max-w-[500px] lg:max-w-none"
        >
            <GamesTable
                games={games}
                onClick={onAnalyzeClick}
                buttonLabel="Analyze"
            />
        </PageCardContainer>
    );
}
